import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { routes } from '../../app.routes';
import { ExternalDataService } from '../external-data/external-data.service';

@Injectable({
  providedIn: 'root',
})
export class ExternalNavigationService {
  private currentForm: string | undefined;

  constructor(private externalDataService: ExternalDataService, private router: Router) {
    this.init();
  }

  private init() {
    this.externalDataService.$form.subscribe((form) => {
      if (this.currentForm === form) {
        return;
      }

      this.currentForm = form;

      const routeFromRoutes = routes.find((route) => route.path === form);
      if (routeFromRoutes) {
        this.router.navigate([routeFromRoutes.path]);
      }
    });
  }
}
